module.exports = __webpack_public_path__ + "static/media/CC1.dc90c03b.jpg";